/** Zamienia nazwę na identyfikator w adresie URL: „Ruda Śląska” → „ruda-slaska”. */
export function slugify(value: string): string {
  return (
    value
      .toLowerCase()
      // „ł” nie ma formy rozłożonej w Unicode, więc normalizacja jej nie usunie.
      .replace(/ł/g, 'l')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
  )
}
